import gbAntFormFilterSearch from "./src/gb-ant-form-filter-search.vue";
const gbAntFormFilterSearchCompenet = function(Vue) {
  Vue.component(gbAntFormFilterSearch.name, gbAntFormFilterSearch);
};
export default gbAntFormFilterSearchCompenet;
